import { useWhatIfPositions } from "@iliotech/data-wire/src/stores";
import { WhatIfPositionsTableCellProps } from "../WhatIfPositionsTable";
import { observer } from "mobx-react-lite";

const OriginalValueCell = ({ index }: WhatIfPositionsTableCellProps) => {
  const store = useWhatIfPositions();
  const currentPrice = store.getField<number>("oldValue", index);

  const formattedValue = currentPrice
    ? currentPrice.toLocaleString(undefined, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      })
    : "";

  return <div>{formattedValue || 0}</div>;
};

export default observer(OriginalValueCell);
